var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',{attrs:{"id":"inspire"}},[(_vm.$store.state.layout.layoutInitialized)?_c('Mainframe'):_c('div',{attrs:{"id":"preloading"}},[_c('div',{staticClass:"qr-loader"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }